<kp-alert title="Tip from the Scrum Poker Team" type="info" alertId="whocan1" i18n-title i18n-messageLine1
    messageLine1="We also built 'Whocan.org' – perfect for your next planning:" i18n-messageLine2
    messageLine2=" Find a date, organize retros, or clarify who takes on which tasks." i18n-messageLine4
    messageLine4="Free and no registration required." goToLink="https://www.whocan.org/%locale%/" i18n-goToText
    goToText="Try it now: Whocan.org">
</kp-alert>
